import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";
import { MpCommonService } from "src/app/services/api/mp-common.service";

import { MpCommonActions } from "../../actions/mp-common.actions";
import { FailState } from "../../models/fail-state";
import { RfSignalsState } from "../../models/mp-common/rf-signals.state";
import { AppState } from "../../reducers";
import { MpCommonSelectors } from "../../selectors/mp-common.selectors";

@Injectable()
export class RfSignalsGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.rfSignals.get),
			withLatestFrom(this.store.select(MpCommonSelectors.rfSignals)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(state)
					? of(MpCommonActions.rfSignals.getSuccess(state))
					: of(MpCommonActions.rfSignals.getApi())
			)
		)
	);

	api = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.rfSignals.getApi),
			switchMap(() =>
				this.mpCommonService.rfSignals().pipe(
					map((rfSignals) =>
						MpCommonActions.rfSignals.getSuccess({ rfSignals, loading: false })
					),
					catchError((error) =>
						of(MpCommonActions.rfSignals.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private store: Store<AppState>,
		private mpCommonService: MpCommonService,
		private actions: Actions
	) {}

	private canUseStoreValue(state: RfSignalsState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
